import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  Button,
  Label,
  FormGroup,
} from "reactstrap";
import MediaQuery from "react-responsive";
import { MainLoader, DataTable } from "../../../../components";
import * as columns from "./_columns";
import { layout } from "../../../../common/constants";
import moment from "moment";

class DailyBalanceDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      sell: null,
    };
  }

  async componentDidMount() {
    for (const sell of this.props.dailyBalance) {
      if (sell.id == this.props.match.params.id) await this.setState({ sell });
    }
  }

  renderField(label, value) {
    return (
      <FormGroup row>
        <Col md="2" lg="2">
          <Label color="red">{label}</Label>
        </Col>
        <Col xs="12" md="5">
          <p className="form-control-static">{value}</p>
        </Col>
      </FormGroup>
    );
  }

  renderFields() {
    const dailyBalance = this.state.sell;
    const customer = dailyBalance.Customer;

    return (
      <div>
        {this.renderField("Cliente:", customer.name + " " + customer.lastname)}
        {this.renderField(
          "Fecha de Atención:",
          moment(dailyBalance.created_at).format("DD-MM-YYYY HH:mm")
        )}
        {this.renderField("Identificador:", dailyBalance.receipt_id)}
        {this.renderField("Tipo de Comprobante:", dailyBalance.receipt_type)}
        {this.renderField(
          "Método de Pago:",
          dailyBalance.Sell_payment_type.name
        )}
      </div>
    );
  }

  renderDataTable(columns, data, total, loading) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        totalSize={total}
        loading={loading}
      />
    );
  }

  render() {
    const { error, loading, dailyBalance } = this.props;
    const { sell } = this.state;
    if (error) {
      return <Alert color="danger">{error}</Alert>;
    }

    if (loading) {
      return <MainLoader />;
    } else if (!sell) {
      return <MainLoader />;
    } else if (!dailyBalance) return <div></div>;

    return (
      <div className="animated">
        <Card>
          <CardHeader>Detalle de la venta</CardHeader>
          <CardBody>
            {this.renderFields()}
            <Row>
              <Col>
                <MediaQuery
                  maxWidth={layout.XS_MAX_WIDTH}
                  maxWidth={layout.MD_MAX_WIDTH}
                >
                  {this.renderDataTable(
                    columns.dailyBalanceDetailXS(),
                    sell.Sell_details,
                    sell.Sell_details.length,
                    loading
                  )}
                </MediaQuery>
                <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                  {this.renderDataTable(
                    columns.dailyBalanceDetail(),
                    sell.Sell_details,
                    sell.Sell_details.length,
                    loading
                  )}
                </MediaQuery>
              </Col>
            </Row>
            <Row>
              <Col className="mt-3">
                <Button
                  color="secondary"
                  onClick={() =>
                    this.props.history.push("/report/dailybalance")
                  }
                >
                  <i className="fa fa-chevron-left mr-1" /> Volver
                </Button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { dailyBalance, error, loading } = state.report.dailyBalanceList;
  return {
    dailyBalance,
    error,
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DailyBalanceDetail);



// WEBPACK FOOTER //
// ./src/scenes/Report/Cash/DailyBalanceDetail/DailyBalanceDetail.js